export function getResizeUrl({ size, url }: { size: string; url: string | URL }): URL {
  return new URL(`https://d2ch1c8885oq0w.cloudfront.net/v3/${size}/filters:format(webp):quality(70)/${url}`)
}

export function getModelThumbnailUrl(url: string | URL): string {
  return getResizeUrl({ size: '600x0', url }).toString()
}

export function getModelHighresUrl(url: string | URL): string {
  return getResizeUrl({ size: '1080x0', url }).toString()
}

// Sized for the AI Fashion Background popover tiles (~100 CSS px wide, 3 cols
// in a 320 px popover). 300 px keeps it crisp at 3x DPR while ~4x cheaper than
// the model thumbnail size, which also has to serve the larger dashboard grid.
export function getBackgroundThumbnailUrl(url: string | URL): string {
  return getResizeUrl({ size: '300x0', url }).toString()
}
